import React from 'react';

export default function Tour({ tour }) {
    return (
        <section id="tour" className=" text-white py-16">
            <div className="max-w-6xl mx-auto px-6">
                <div className="flex items-center justify-between">
                    <div>
                        <h3 className="text-2xl font-bold">Concerts à venir</h3>
                    </div>
                </div>

                <ul className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
                    {tour.map((t, i) => (
                        <li
                            key={i}
                            className="p-5 rounded-2xl bg-white/10 backdrop-blur-sm 
                                       border border-white/10 shadow-lg 
                                       hover:bg-white/20 transition-all"
                        >
                            <div className="text-sm text-red-400 font-medium">
                                {new Date(t.date_concert).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    timeZone: "UTC"
                                })}
                            </div>

                            <div className="mt-2 font-semibold text-white text-lg">
                                {t.lieu}
                            </div>

                            <div className="text-sm text-gray-300">
                                {t.ville}
                            </div>

                            {t.lien !== "#" && (
                                <div className="mt-4">
                                    <a
                                        href={t.lien}
                                        className="inline-block px-4 py-2 rounded-md border border-red-500 
                                                   text-red-400 hover:bg-red-600 hover:text-white
                                                   transition-colors text-sm"
                                    >
                                        Infos
                                    </a>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
